import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectGatewayRegistriesListItems } from "../../../../../redux/gateway-registries/selector";
import { gatewayRegistries } from "../../../../../redux/gateway-registries/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";

const EdgeGatewayRegistries = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const gatewayItems = useSelector(selectGatewayRegistriesListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'GatewayName', headerName: 'Gateway Name', searchField: 'Name', filter: true,
        filterType: 'text' },
        { field: 'DBAName', headerName: 'DBA Name', searchField: 'Name', filter: true,
          filterType: 'text' },
    ]);
  }

  
  const fetchGatewaysList = () => {
    dispatch(gatewayRegistries.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries/fetch`,
      entity: 'gatewayRegistries',
      jsonData: {
        Context: {},
        Records: [
          {
           
          },
        ],
        Pagination: {
          PageNumber: 1,
          PageSize: 100,
          SortField: "DisplayOrder",
          SortOrder: "desc",
        },
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchGatewaysList()
  }, [pageData,pageSize])


  const handleEdit = (data: any) => {
    navigate(`${data?.GatewayRegistryId}/${data?.TenantId}`)
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  
  const handleReloadData = () => {
    fetchGatewaysList();
  }
 
  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(gatewayRegistries.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/gateway-registries/fetch`,
      entity: 'gatewayRegistries',
      jsonData: {
        Context: {},
        Records: [
          {
           
          },
        ],
        Pagination: {
          "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
        },
      }
    }));
  }

 
 
  return (
    <>
 
      {gatewayItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={gatewayItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        enableFilter={true} onSearch={handleSearch}
          paginationData={gatewayItems?.result?.pagination} onEdit={handleEdit} 
         additionButtons={additionButtons} headingName="Gateway Registries" checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: 'Id',
      }} />
      }
    </>
  );
};

export default EdgeGatewayRegistries;


